module.exports = __webpack_public_path__ + "img/ecv-home.010d4e01.gif";